class ProductForm extends HTMLElement {

  constructor() {
    super();

    // Scope
    const self = this;

    // Scope elements
    self.form = self.querySelector('form');
    self.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    self.cartDrawer = document.querySelector('cart-drawer');
    self.cartItems = document.querySelector('cart-items');
    self.nextStepButton = self.querySelector('[data-product-next-step]');
  }

  /**
   * Handle the on form submit
   * @returns void
   */
  onSubmitHandler(event) {

    // Scope
    const self = this;

    event.preventDefault();

    let allowSubmit = true;
    const requiredItems = this.form.querySelectorAll('[data-ajax-cart-required]');
    const requiredError = this.form.querySelector('[data-ajax-cart-required-error]');
    let missingItems = [];
    const submitButton = this.querySelector('[type="submit"]');

    // This item is hidden by default, hide it when submitting as well
    if (requiredError) {
      requiredError.classList.add('visually-hidden');
    }

    // Check if we have required elements to check
    if (requiredError && requiredItems.length > 0) {
      requiredItems.forEach((requiredItem) => {
        if (!requiredItem.value || requiredItem.value === '') {
          missingItems?.push('<strong>' + requiredItem.dataset.ajaxCartRequired + '</strong>');

          // Focus on and Add error class to the input if it has the data-symbol-input attribute
          if (requiredItem.hasAttribute('data-symbol-input')) {
            trapFocus(requiredItem);
            requiredItem.classList.add('field__input--error');

            // reset the error style and message when the input is focused
            requiredItem.addEventListener('focus', () => {
              requiredItem.classList.remove('field__input--error');
              requiredError.classList.add('visually-hidden');
            });
          }

          allowSubmit = false;
        }
      });
    }

    if (allowSubmit) {

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id)
      ];
      const formObject = JSON.parse(serializeForm(this.form));

      const formItems = {
        items: [
          {
            id: formObject.id,
            quantity: formObject.quantity,
            properties: {}
          }
        ]
      };

      for (const key in formObject) {
        if (key.startsWith('properties[')) {
          let property_key = key.replace('properties[', '').replace(']', '');
          formItems.items[0].properties[property_key] = formObject[key];
        }
      }

      const body = JSON.stringify(formItems);

      this.cartItems.enableLoading();

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then(()=>{
          return this.cartItems.refreshInterface();
        })
        .then(()=>{
          this.cartItems.disableLoading();
          if (!self.nextStepButton) {
            this.cartDrawer.open();
          }
        })
        .then(()=>{
          return this.cartItems.addFreeProductToCart();
        })
        .then(() => {
          // Check if we have a free gift to add to the cart as well
          if (document.querySelector('[data-free-gift]')) {
            this.cartItems.refreshInterface();
          }
        })
        .then(()=>{
          if (this.cartItems.cartHasGiftWrapDirectlyAttribute) {
            return fetch(`${routes.cart_url}.json`)
            .then((response) => response.json())
            .then((cart)=>{
              return this.cartItems.updateGiftWrapProductInCart(cart);
            })
            .then(() => {
              return this.cartItems.refreshInterface();
            });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartItems.disableLoading();
          submitButton.classList.remove('loading');

          // Check if a next step button is available
          if (self.nextStepButton) {
            submitButton.innerHTML = self.nextStepButton.dataset.successTranslationLabel;
            self.nextStepButton.classList.remove('button--disabled');
          } else {
            submitButton.removeAttribute('disabled');
          }
        });

    }
    else {

      // Scroll to the top to show errors
      if (self.windowWidth >= 768) {
        self.handleScrollTop();
      }

      // Show the required error
      requiredError.innerHTML = requiredError.dataset.ajaxCartRequiredError + ' ' + missingItems.join(', ');
      requiredError.classList.remove('visually-hidden');
      submitButton.blur();
    }
  }


}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
